import { Flex, Text, chakra } from '@chakra-ui/react';
import type { OnboardingFormReturn, TshirtSize } from '../useOnboardingForm';

export function SizeStep({ form }: { form: OnboardingFormReturn }) {
  const { tshirtSize, setTshirtSize, sizeOptions } = form;
  return (
    <Flex direction="column" gap="4">
      <Text fontSize="md" color="volyx.textSecondary">
        Pick a t-shirt size so organizations can prepare apparel if they hand any out.
      </Text>
      <Flex gap="2" flexWrap="wrap">
        {sizeOptions.map((size) => {
          const active = size === tshirtSize;
          return (
            <chakra.button
              key={size}
              type="button"
              px="5"
              py="3"
              borderRadius="xl"
              fontWeight="semibold"
              transition="all 0.2s"
              cursor="pointer"
              border="none"
              minW="56px"
              outline="none"
              _focus={{ outline: 'none' }}
              bg={active ? 'volyx.action' : 'volyx.lightGray'}
              color={active ? 'white' : 'volyx.text'}
              _hover={!active ? { bg: 'volyx.mediumGray' } : undefined}
              onClick={() => setTshirtSize(size as TshirtSize)}
            >
              {size}
            </chakra.button>
          );
        })}
      </Flex>
      {tshirtSize ? (
        <Text fontSize="sm" color="volyx.textSecondary">
          Selected: <chakra.span fontWeight="semibold" color="volyx.primary">{tshirtSize}</chakra.span>
        </Text>
      ) : null}
    </Flex>
  );
}
